<script>
  // @ts-check
  // eslint-disable-next-line no-unused-vars
  import * as Types from "./globalFooterTypes.js";
  // eslint-disable-next-line no-unused-vars
  import * as Themes from "../../utilities/themes.js";

  import Link from "../../atoms/Link.svelte";
  import MenuNavigationCard from "../../molecules/Cards/MenuNavigationCard.svelte";

  /**
   * The type of column
   * @type {string}
   */
  export let type;

  /**
   * The style of each column
   * @type {string}
   */
  export let columnClass;

  /**
   * The title of the column section
   * @type {string}
   */
  export let title;

  /**
   * The main links data in the columns in the body of the footer
   * @type {Types.CardContent}
   */
  export let card;

  /**
   * The main links data in the columns in the body of the footer
   * @type {Types.Link[]}
   */
  export let links;

  /**
   * @type {Themes.ThemeName}
   */
  export let themeName = "cobaltBlue";

  // This class is needed to make the words break as expected by the layout
  const columnItemClass = "lg:max-w-60 xl:max-w-80";
</script>

<div class="border-t-thin pt-4 sm:col-span-11 md:col-span-6 lg:col-span-3 {columnClass}">
  {#if !!title}
    <div class="label pb-4">{title}</div>
  {/if}
  {#if type === "links"}
    <ul class={columnItemClass}>
      {#each links as link}
        <li class="py-2">
          <Link
            id={link.id}
            class="block md:inline-flex"
            href={link.href}
            label={link.text}
            variant="small"
            isExternal={link.isExternal}
            showLinkArrowOnHover={!link.isExternal}
            theme="cobaltBlue"
          />
        </li>
      {/each}
    </ul>
  {/if}
  {#if type === "card"}
    <MenuNavigationCard
      theme={themeName}
      containerClass="col-span-4 block"
      cardContent={card}
      showRule={false}
      labelClass="cta-md sm:mt-6 md:mt-5 xl:mt-7.5"
      id={card?.id}
      showLinkIcon
    />
  {/if}
</div>
